import { Crown, TriangleAlert } from "lucide-react";

/** Small status banner shown atop the bid panel based only on existing data. */
export function BidStatusBanner({
  state,
}: {
  state: "winning" | "outbid" | "reserve" | null;
}) {
  if (!state) return null;
  if (state === "winning") {
    return (
      <div
        role="status"
        aria-live="polite"
        className="mb-4 flex items-center gap-2 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-300 animate-fade-in"
      >
        <Crown className="h-4 w-4" /> You are the highest bidder
      </div>
    );
  }
  if (state === "outbid") {
    return (
      <div
        role="status"
        aria-live="polite"
        className="mb-4 flex items-center gap-2 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm text-amber-300 animate-fade-in"
      >
        <TriangleAlert className="h-4 w-4" /> You've been outbid — place a new bid to stay in
      </div>
    );
  }
  return null;
}
